<template>
  <button @click="subscribe" class="btn btn-primary">สมัครรับการแจ้งเตือน</button>
</template>

<script>
import { subscribeUserToPush } from "@/utils/push";

export default {
  methods: {
    subscribe() {
      subscribeUserToPush();
    }
  }
};
</script>